import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegexPattern } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-registration-organization-specific-data',
  templateUrl: './registration-organization-specific-data.component.html',
  styleUrls: ['./registration-organization-specific-data.component.scss', '../registration.scss'],
})
export class RegistrationOrganizationSpecificDataComponent {
  @Input() organizationSpecificDataForm!: FormGroup;
  @Input() showError = false;

  protected readonly Validators = Validators;

  get furtherKins(): FormArray {
    return this.organizationSpecificDataForm.controls['furtherKins'] as FormArray;
  }

  public static generateFormGroup(): FormGroup {
    return new FormGroup({
      masterKin: new FormControl('', [Validators.pattern(RegexPattern.MASTER_KIN)]),
      furtherKins: new FormArray([]),
      crmId: new FormControl(''),
    });
  }

  addFurtherKin(): void {
    const furtherKinForm = new FormGroup({
      kin: new FormControl('', [Validators.required, Validators.pattern(RegexPattern.MASTER_KIN)]),
    });
    this.furtherKins.push(furtherKinForm);
  }

  removeFurtherKin(index: number): void {
    this.furtherKins.removeAt(index);
  }
}
